// ===================================================================
// KAIXO - VersionUpdateBanner
// ===================================================================
// Banner overlay que aparece cuando el hook useVersionCheck detecta
// que el servidor publicó una versión nueva. Muestra spinner + texto
// "Actualizando KAIXO" durante ~1.5s y la app se recarga automáticamente.
//
// Importante: no requiere acción del usuario. El JWT y los datos del
// usuario están en localStorage que sobrevive al reload — al volver
// a cargar, el usuario sigue logueado en el mismo sitio.
// ===================================================================

import React from 'react';
import ReactDOM from 'react-dom';
import useVersionCheck from '../../hooks/useVersionCheck';
import './VersionUpdateBanner.css';

export default function VersionUpdateBanner() {
    const { updateAvailable, reloading } = useVersionCheck();
    const visible = updateAvailable || reloading;
    if (!visible) return null;

    return ReactDOM.createPortal(
        <div className="vub-overlay" role="status" aria-live="polite">
            <div className="vub-card">
                <div className="vub-spinner" aria-hidden="true">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <circle cx="18" cy="18" r="14" stroke="rgba(255,255,255,0.25)" strokeWidth="3" />
                        <path d="M32 18a14 14 0 0 0-14-14" stroke="white" strokeWidth="3" strokeLinecap="round" />
                    </svg>
                </div>
                <div className="vub-text">
                    <strong>Actualizando KAIXO…</strong>
                    <span>La app se reinicia sola, no toques nada.</span>
                </div>
            </div>
        </div>,
        document.body
    );
}
